import { render, staticRenderFns } from "./PromotionBannerKeys.vue?vue&type=template&id=0490012a&scoped=true&"
import script from "./PromotionBannerKeys.vue?vue&type=script&lang=js&"
export * from "./PromotionBannerKeys.vue?vue&type=script&lang=js&"
import style0 from "./PromotionBannerKeys.vue?vue&type=style&index=0&id=0490012a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490012a",
  null
  
)

export default component.exports